var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "itinerary itinerary-promo mb-3",
      class: { active: _vm.visible },
    },
    [
      _c("div", { staticClass: "itinerarySummary" }, [
        _c("div", { staticClass: "itinerarySummary__destinations" }, [
          _c("div", { staticClass: "row gy-5" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-xl-8 d-flex align-items-center justify-content-center",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "itinerarySummary__destination itinerarySummary__destination--start",
                  },
                  [
                    _c("div", [
                      _c("div", { staticClass: "city" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.stationFrom) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(
                          "\n               " +
                            _vm._s(_vm.timeStart) +
                            "\n              "
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "itinerarySummary__number" }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.duration) + "\n            "
                  ),
                  _c("hr"),
                  _vm._v(" "),
                  _c("small", [
                    _vm._v(_vm._s(_vm.trainNumber)),
                    _vm.change ? _c("br") : _vm._e(),
                    _vm._v(_vm._s(_vm.change)),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "itinerarySummary__destination itinerarySummary__destination--end",
                  },
                  [
                    _c("div", [
                      _c("div", { staticClass: "city" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.stationTo) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.timeEnd) +
                            "\n              "
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-xl-4 d-flex align-items-center justify-content-xl-end justify-content-center",
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.trainType,
                        expression: "trainType",
                      },
                    ],
                    staticClass:
                      "itinerarySummary__type order-2 order-xl-1 mx-2",
                  },
                  [
                    _c("i", {
                      class: "product-icon product-icon-" + _vm.trainType,
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "itinerarySummary__price order-3 order-xl-2 mx-2",
                  },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.price))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.trainClass))]),
                  ]
                ),
                _vm._v(" "),
                _vm.buyButton
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "itinerarySummary__button-std order-1 order-xl-3 mx-2",
                      },
                      [
                        _vm._t("buy-button-slot", function () {
                          return [_vm._v("def")]
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }